import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from './locales/i18n';
import AllProfilesContext from './contexts/AllProfilesContext';
import DataProvider from './contexts/filterDataContext';
import RouterNavigate from './routes';
import AppContext from './contexts/AppContext';
import { CoreProvider } from './contexts/CoreContext';

const App = () => {
  return (
    <div className="app-container-corporates-club" data-testid="app-corporate-club">
      <CoreProvider>
        <I18nextProvider i18n={i18next}>
          <AllProfilesContext>
            <AppContext>
              <DataProvider>
                <RouterNavigate />
              </DataProvider>
            </AppContext>
          </AllProfilesContext>
        </I18nextProvider>
      </CoreProvider>
    </div>
  );
};

export default App;
